import * as Dialog from "@radix-ui/react-dialog";
import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  content?: React.ReactNode;
  children?: React.ReactNode;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
};

export default function Modal$Header({
  className,
  style,
  content,
  children = content,
  iconLeft,
  iconRight,
}: Props) {
  return (
    <Dialog.Title asChild>
      <div className={cx(styles.container, className)} style={style}>
        <Flex.Row
          gap="20px"
          flex="1 1 0"
          justifyContent="center"
          alignItems="center"
        >
          <div className={styles.iconSlot}>{iconLeft}</div>
          <Flex.Cell flex="1 1 0">{children}</Flex.Cell>
          <div className={styles.iconSlot}>{iconRight}</div>
        </Flex.Row>
      </div>
    </Dialog.Title>
  );
}
